import { jsx, jsxs } from 'react/jsx-runtime';
import { useDevice } from '../../contexts/DeviceContext.js';
import { cn } from '../../lib/utils.js';

const ProcessList = ({ children, className = "" }) => {
  return /* @__PURE__ */ jsx("div", { className: cn("flex flex-col py-4", className), children });
};
const ProcessListItem = ({ icon, title, desc }) => {
  const { isDesktop } = useDevice();
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex pb-8 flex-col process",
        !desc && "justify-center",
        isDesktop && "pb-12 min-height-[62px] after:w-6 after:h-6 after:[mask-size:24px]"
      ),
      children: [
        icon && /* @__PURE__ */ jsx(
          "span",
          {
            className: cn(
              "absolute top-1 left-1 flex flex-grow flex-shrink-0 basis-auto items-center justify-center w-[52px] min-h-[52px] rounded-full bg-primary-background-07 process-img",
              isDesktop && "min-h-[60px] w-[60px]"
            ),
            children: icon
          }
        ),
        /* @__PURE__ */ jsxs(
          "dl",
          {
            className: cn(
              "flex flex-col gap-0.5 basis-full pl-[68px] min-h-[52px] justify-center",
              isDesktop && "pl-[80px] min-h-[60px] gap-1"
            ),
            children: [
              title && /* @__PURE__ */ jsx(
                "dt",
                {
                  className: cn(
                    "font-weight-medium text-basic-01 mt-[4px]",
                    isDesktop ? "heading-h5" : "body-lg"
                  ),
                  children: title
                }
              ),
              desc && /* @__PURE__ */ jsx("dd", { className: "body-md text-basic-04", children: desc })
            ]
          }
        )
      ]
    }
  );
};

export { ProcessList, ProcessListItem };
